const internalOrigin = 'https://internal.invalid'

export const getSafeInternalRedirect = (value: unknown): string | undefined => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return undefined
  }

  if (/\\|[\u0000-\u001f\u007f]/.test(value)) {
    return undefined
  }

  try {
    const url = new URL(value, internalOrigin)
    if (url.origin !== internalOrigin) return undefined

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return undefined
  }
}

export const addInternalRedirectSearchParam = (
  redirect: string,
  name: string,
  value: string
): string => {
  const url = new URL(redirect, internalOrigin)
  url.searchParams.set(name, value)

  return `${url.pathname}${url.search}${url.hash}`
}
